import { useEffect } from 'react';
import { isBefore, isEqual, differenceInMilliseconds, parseISO } from 'date-fns';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { clearTradingBlockExpiryDateAction, getTradingAccounts } from '../actions';
import { selectTradingAccount } from '../reducers/selectors';
/**
 * sets a timer to clear the buy block date and fetch trading account
 */
export const useClearBuyBlock = () => {
    const dispatch = useAppDispatch();
    const tradingAccount = useAppSelector(selectTradingAccount);
    const tradingBlockExpiryDate = tradingAccount?.account.tradingBlockExpiryDate;
    useEffect(() => {
        let timer;
        if (tradingBlockExpiryDate) {
            const now = new Date();
            const tradingBlockExpiryDateLocal = parseISO(tradingBlockExpiryDate);
            if (isBefore(tradingBlockExpiryDateLocal, now) || isEqual(tradingBlockExpiryDateLocal, now)) {
                dispatch(clearTradingBlockExpiryDateAction());
            }
            else {
                const timeDiff = differenceInMilliseconds(tradingBlockExpiryDateLocal, now);
                timer = setTimeout(() => {
                    dispatch(clearTradingBlockExpiryDateAction());
                    dispatch(getTradingAccounts());
                }, timeDiff);
            }
        }
        return () => {
            clearTimeout(timer);
        };
    }, [dispatch, tradingBlockExpiryDate]);
};
